/**
 * Shared styling for report variable modals & form controls
 * (aligned with variable-sketch-editor-dialog).
 */

export const RV_DIALOG_Z = "relative z-[3600]";
export const RV_DIALOG_Z_POPOVER = "relative z-[3610]";

/** PMCustomSelector / lists opened inside report variable modals (above dialog + nested popovers). */
export const RV_SELECTOR_OVER_DIALOG_Z = 3700;

export const RV_OVERLAY_CLASS = "fixed inset-0 bg-black/60";

export const rvTransitionOverlay = {
  enter: "ease-out duration-200",
  enterFrom: "opacity-0",
  enterTo: "opacity-100",
  leave: "ease-in duration-150",
  leaveFrom: "opacity-100",
  leaveTo: "opacity-0",
};

export const rvTransitionPanel = {
  enter: "ease-out duration-300",
  enterFrom: "opacity-0 translate-y-6 sm:translate-y-0 sm:scale-95",
  enterTo: "opacity-100 translate-y-0 sm:scale-100",
  leave: "ease-in duration-200",
  leaveFrom: "opacity-100 translate-y-0 sm:scale-100",
  leaveTo: "opacity-0 translate-y-6 sm:translate-y-0 sm:scale-95",
};

export const RV_CENTER_WRAPPER = "fixed inset-0 overflow-y-auto";
export const RV_CENTER_INNER =
  "flex min-h-full items-end justify-center p-0 sm:items-center sm:p-4";

/** ~md form dialogs (group, variable, type selector) */
export const RV_PANEL_MD =
  "flex max-h-[100dvh] w-full max-w-full transform flex-col overflow-y-auto rounded-t-3xl border border-gray-200 bg-white px-5 pb-[max(1rem,env(safe-area-inset-bottom))] pt-5 text-left shadow-2xl transition-all sm:max-h-[min(90vh,48rem)] sm:max-w-md sm:rounded-3xl sm:p-6";

/** Wider (type group + measurement) */
export const RV_PANEL_LG =
  "flex max-h-[100dvh] w-full max-w-full transform flex-col overflow-y-auto rounded-t-3xl border border-gray-200 bg-white px-5 pb-[max(1rem,env(safe-area-inset-bottom))] pt-5 text-left shadow-2xl transition-all sm:max-h-[min(90vh,52rem)] sm:max-w-2xl sm:rounded-3xl sm:p-6";

/** Bulk-add table */
export const RV_PANEL_XL =
  "flex max-h-[100dvh] w-full max-w-full transform flex-col overflow-hidden rounded-t-3xl border border-gray-200 bg-white px-5 pb-[max(1rem,env(safe-area-inset-bottom))] pt-5 text-left shadow-2xl transition-all sm:max-h-[90vh] sm:max-w-4xl sm:rounded-3xl sm:px-6 sm:pb-6 sm:pt-6";

export const RV_DIALOG_TITLE = "text-lg font-semibold text-gray-900";

export const RV_INPUT =
  "w-full rounded-2xl border border-gray-200 bg-gray-50 px-4 py-3 text-base font-medium text-gray-900 placeholder:text-gray-400 focus:border-gray-900 focus:outline-none focus:ring-1 focus:ring-gray-900/20 disabled:opacity-60";

export const RV_INPUT_COMPACT =
  "w-full rounded-xl border border-gray-200 bg-gray-50 px-3 py-2 text-sm font-medium text-gray-900 placeholder:text-gray-400 focus:border-gray-900 focus:outline-none focus:ring-1 focus:ring-gray-900/20";

export const RV_INPUT_MEASURED =
  "w-full rounded-2xl border border-emerald-200/80 bg-emerald-50/50 px-4 py-3 text-base font-medium text-gray-900 placeholder:text-gray-400 focus:border-emerald-700 focus:outline-none focus:ring-1 focus:ring-emerald-700/20";

export const RV_BTN_OUTLINE_SM =
  "inline-flex shrink-0 items-center justify-center rounded-xl border border-gray-300 bg-white px-4 py-2.5 text-sm font-medium text-gray-800 shadow-sm transition hover:bg-gray-50 disabled:pointer-events-none disabled:opacity-50";

export const RV_BTN_OUTLINE =
  "inline-flex items-center justify-center rounded-2xl border border-gray-300 bg-white px-5 py-3 text-sm font-medium text-gray-800 shadow-sm transition hover:bg-gray-50 disabled:pointer-events-none disabled:opacity-50";

export const RV_BTN_PRIMARY_DARK =
  "inline-flex items-center justify-center rounded-2xl border border-gray-900 bg-gray-900 px-5 py-3 text-sm font-semibold text-white shadow-sm transition hover:bg-gray-800 disabled:pointer-events-none disabled:opacity-50";

export const RV_SECTION =
  "rounded-2xl border border-gray-200 bg-gray-50/80 p-4";

export const RV_CLOSE_BTN =
  "shrink-0 rounded-lg p-2 text-gray-400 transition hover:bg-gray-100 hover:text-gray-600";

export const SKETCH_TOTAL_DOT_COLORS = [
  "bg-gray-700",
  "bg-slate-600",
  "bg-zinc-600",
  "bg-stone-600",
  "bg-neutral-600",
];
